import { render, staticRenderFns } from "./CustomerNonActive.vue?vue&type=template&id=570754df&"
import script from "./CustomerNonActive.vue?vue&type=script&lang=js&"
export * from "./CustomerNonActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports